<template>
	<div class="blackscreen" @click="close">
		<div class="modal">
			<div v-if="object.urlObjeto" class="download-file" @click="downloadFile">
				<i class="fas fa-download"></i>
				<span>Downloads</span>
			</div>

			<div class="preview-container" v-if="object.tipoNome === 'Vídeos' && object.urlObjeto" v-html="object.urlObjeto"></div>
			<div class="preview-container" v-else-if="object.tipoNome === 'Podcasts'">
				<div class="audio-bg" :style="`background-image: url(${object.urlImagemCapa})`">
					<div class="audio-title">
						{{ object.nome }}
					</div>
					<audio controls>
						<source :src="object.urlObjeto" />
					</audio>
				</div>
			</div>
			<div class="preview-container" v-else>
				<iframe :src="viewerURL + object.urlObjeto" scrolling="no"></iframe>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ContentPreview',
	props: {
		object: {
			type: Object
		},
		viewerURL: {
			type: String,
			default: 'https://view.officeapps.live.com/op/embed.aspx?src='
		},
		viewerTypes: {
			type: Function,
			default: () => ['Livro', 'Documentos', 'Imagem', 'Links']
		}
	},
	methods: {
		close (evt) {
			if (!evt.target.closest('.modal')) {
				this.$emit('closePreview')
			}
		},
		downloadFile () {
			this.$emit('downloadFile')
		}
	}
}
</script>

<style lang="scss" scoped>
	.blackscreen {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
		background-color: transparent;
		animation: showPreview-blackScreen .667s forwards;

		.modal {
			position: relative;
			width: 1300px;
			height: 700px;
			background-color: #FFF;
			box-shadow: #CCC3 1px 1px 2px 2px;
			animation: showPreview-modal 1s forwards;
			animation-delay: .667s;
			transform: scale(0);
			overflow: hidden;

			.download-file {
				position: absolute;
				top: 45%;
				right: 0;
				z-index: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 120px;
				height: 50px;
				padding: 10px;
				background-color: #00659D;
				color: #FFF;
				cursor: pointer;
				transform: translateX(83px);
				transition: .333s transform;

				&:hover {
					transform: translateX(0);
				}

				span {
					display: inline-block;
					margin-left: 10px;
				}
			}

			.preview-container {
				width: 100%;
				height: 100%;

				.audio-bg {
					position: relative;
					width: 100%;
					height: 100%;
					background-color: #777;
					background-size: contain;
					background-position: center;
					background-repeat: no-repeat;

					&:hover {
						.audio-title {
							opacity: 1;
						}
					}

					.audio-title {
						padding: 15px 16px;
						background-image: linear-gradient(to bottom, #000A, transparent);
						color: #FFF;
						font-size: 1.2em;
						opacity: 0;
						transition: .667s opacity;
					}

					audio {
						position: absolute;
						bottom: 0;
						width: 100%;
					}
				}
			}
		}
	}

	@keyframes showPreview-blackScreen {
		to { background-color: #0007 }
	}

	@keyframes showPreview-modal {
		to { transform: scale(1) }
	}
</style>

<style>
	iframe {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
</style>
